import { render } from "./CredibilitySection.vue?vue&type=template&id=77b7ca62&scoped=true"
import script from "./CredibilitySection.vue?vue&type=script&lang=js"
export * from "./CredibilitySection.vue?vue&type=script&lang=js"

import "./CredibilitySection.vue?vue&type=style&index=0&id=77b7ca62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b7ca62"]])

export default __exports__